module.exports = __webpack_public_path__ + "img/ic_yuncangshangchang@2x(1).f6ea1e78.png";